// Shared client-side image compressor. Extracted from
// src/routes/index.tsx so the share-intent flow can mirror the in-app
// handleAnalyse upload path (F.5e).
//
// Behavior: scales the longest edge down to 1200px (if larger), re-encodes
// as JPEG at quality 0.85. Returns the original file on any failure so
// callers never break on edge cases (non-images, decode errors, etc.).
export async function compressImage(file: File): Promise<File> {
  return new Promise((resolve) => {
    try {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) return resolve(file);
      const img = new window.Image();
      img.onload = () => {
        const maxDim = 1200;
        let width = img.width;
        let height = img.height;
        if (width > maxDim || height > maxDim) {
          if (width > height) {
            height = (height / width) * maxDim;
            width = maxDim;
          } else {
            width = (width / height) * maxDim;
            height = maxDim;
          }
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) return resolve(file);
            const baseName = file.name.replace(/\.[^.]+$/, "");
            resolve(new File([blob], `${baseName}.jpg`, { type: "image/jpeg" }));
          },
          "image/jpeg",
          0.85,
        );
      };
      img.onerror = () => resolve(file);
      img.src = URL.createObjectURL(file);
    } catch {
      resolve(file);
    }
  });
}
